import http from '@/utils/http' //引入axios
export const getDidiUser = data => http.get('/kg-payment/api/dof/user', {
    params: data
})
export const ChangeDidiUser = data => http.put('/kg-payment/api/dof/user', data)
export const exportCord = data => http.get('/kg-payment/api/dof/user/excel', {
    params: data,
    responseType: 'blob'
})
export default {
    getDidiUser,
    ChangeDidiUser,
    exportCord

}